"use client";

import { useTranslations } from "next-intl";

import type { ArticleMeta } from "@/integrations/articles";
import { cn } from "@/lib/utils/cn";

import { ArticleCard } from "./ArticleCard";

interface LatestArticlesProps {
  articles: ArticleMeta[];
  limit?: number;
  className?: string;
}

export function LatestArticles({ articles, limit = 3, className }: LatestArticlesProps) {
  const t = useTranslations("pages.articles");

  if (articles.length === 0 || limit <= 0) {
    return null;
  }

  const limited = articles.slice(0, limit);

  return (
    <section className={cn("space-y-4", className)}>
      <h2 className="sr-only font-heading text-2xl text-ink">{t("heading")}</h2>
      <ul className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {limited.map((article) => (
          <li key={`${article.locale}-${article.slug}`}>
            <ArticleCard article={article} />
          </li>
        ))}
      </ul>
    </section>
  );
}
